import * as api from '@api'
import { useQuery } from '@/hooks/useApi'

interface WorkflowTraceTotal {
  balance: number
  reserved: number
  consumed: number
}

export function useWorkflowTraceTotal({ enabled }: { enabled: boolean }) {
  const { data, isLoading, error } = useQuery<WorkflowTraceTotal>(
    ['tracingAiWorkflowTraceTotal'],
    async () => {
      const response = await api.backend.tracingAiWorkflowTraceTotal()
      if (!response.data?.data) {
        throw new Error('No data returned from API')
      }
      return response.data.data
    },
    {
      enabled,
    },
  )

  return {
    data,
    isLoading,
    error: error as Error | null,
  }
}
